import React from 'react';
import { Link } from 'react-router-dom';
import { trackButtonClick } from '../utils/analytics';

const CTA = () => {
  const handleDemoClick = () => {
    trackButtonClick('request_demo', 'cta_section');
  };

  return (
    <section className="py-20 bg-purple-900 text-white">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-4xl font-bold mb-6">
          If you're not red teaming your AI, attackers will
        </h2>
        <p className="text-xl mb-10">
          Get Revelio AI today and secure your organization's AI applications
        </p>
        <div className="flex justify-center space-x-4">
          <Link 
            to="/demo" 
            className="px-8 py-3 bg-red-600 hover:bg-red-700 text-white font-medium rounded-lg transition-all"
            onClick={handleDemoClick}
          >
            Get a Demo
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CTA;